<template>
  <v-dialog scrollable v-model="dialog" persistent max-width="800">
    <material-card
      :title="$t('components.memberview.transfer_out_{0}', [memberName])"
      icon="person_add_alt"
      :color="$vuetify.theme.themes.light.success"
      v-if="dialog"
    >
      <v-card-text>
        {{ $t("components.memberview.tranfer_out_info") }}
      </v-card-text>
      <v-card-text>
        {{ $t("components.memberview.tranfer_out_info2") }}
      </v-card-text>
      <v-card-text>
        <v-form v-model="valid" ref="form">
          <v-container fluid grid-list-md>
            <v-row>
              <v-col>
                <pbas-date-picker
                  :label="$t('components.memberview.transfer_out_date')"
                  :value="item.TransferOutDate"
                  @update-date="item.TransferOutDate = $event"
                  :rules="[$rules.required, coverageEffectiveDateRule]"
                  class="required"
                  :allowedDates="coverageAllowedDates"
                ></pbas-date-picker>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn color text @click="$emit('close')">
          {{ $t("globals.cancel") }}
        </v-btn>
        <v-btn
          :disabled="!valid"
          :loading="loading"
          color="primary"
          @click="$emit('save')"
        >
          {{ $t("components.memberview.transfer_out") }}
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import CurrencyTextfield from "@/components/CurrencyTextfield.vue";
import TransEnum from "@/components/TransEnum.vue";
import ErrorHandler from "@/components/ErrorHandler";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield.vue";

export default {
  components: {
    CurrencyTextfield,
    TransEnum,
    ErrorHandler,
    NoAutocompleteTextfield,
  },
  props: ["memberName", "planEntryDate", "item", "dialog", "loading"],
  data() {
    return {
      valid: false,
      error: undefined,
      coverageEffectiveDateRule: (v) => {
        if (v === undefined || v === null || v === "") {
          return true;
        }
        if (!this.isDate(v)) {
          return this.$t("validation.date_{0}", [this.formatValidationDate(d)]);
        }
        if (this.planEntryDate === null || this.planEntryDate === undefined) {
          return true;
        }
        const n = Date.parse(this.planEntryDate);
        const d = new Date(n);
        const val = new Date(Date.parse(v));
        return (
          val >= d ||
          this.$t("validation.date_{0}", [this.formatValidationDate(d)])
        );
      },
    };
  },
  watch: {},
  computed: {
    ...mapGetters("plansMembers", ["options"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("auth", ["user"]),
  },
  async mounted() {},
  methods: {
    isDate(val) {
      if (
        new RegExp(/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/).test(
          val
        )
      ) {
        return !isNaN(Date.parse(val));
      }
      return false;
    },
    coverageAllowedDates(val) {
      const n = Date.parse(val);
      const d = new Date(n);
      const n2 = Date.parse(this.planEntryDate);
      const d2 = new Date(n2);
      console.log("cad: ", d, d2, d>= d2, this.planEntryDate)
      return d >= d2;
    },
    formatValidationDate(d) {
      let month = (d.getUTCMonth() + 1).toString();
      if (month.length === 1) {
        month = "0" + month;
      }
      let day = d.getUTCDate().toString();
      if (day.length === 1) {
        day = "0" + day;
      }
      return `${d.getUTCFullYear()}-${month}-${day}`;
    },
    reload() {
      if (this.$refs.table) {
        this.$refs.table.reload();
      }
      // if (this.$refs.transactions) {
      //   this.$refs.transactions.reload();
      // }
    },
  },
};
</script>
